












import { Component, Prop, Vue } from 'vue-property-decorator';

import SocialShareButton, {
  SocialShareButtonData
} from '@/componentsV2/molecules/SocialShareButton/SocialShareButton.vue';
import { EASocialMedia } from '@/components/molecules/SocialMediaButton/SocialMediaButton.vue';
import segmentIo from '@/utils/segment.io';

export function defaultSocialNetworks() {
  return ['facebook', 'twitter', 'linkedin', 'copyLink'];
}

@Component({
  components: {
    SocialShareButton
  }
})
export default class ShareButtons extends Vue {
  @Prop({ default: () => defaultSocialNetworks() })
  networks?: EASocialMedia[];
  @Prop() shareData!: SocialShareButtonData[];
  /* Where the buttons are shown; required so no share surface goes untracked (TWISM-20407). */
  @Prop({ required: true }) origin!: string;

  get businessId() {
    const info = this.$store.getters['business/getBusinessInfo'];
    return info && info.business ? info.business.id : '';
  }

  onOpen(network: EASocialMedia) {
    /* Same event and Target ids as the host's ShareActions, which calls Twitter `x`. */
    segmentIo.track('Share Option Clicked', {
      'Business Id': this.businessId,
      Origin: this.origin,
      Target: network === EASocialMedia.twitter ? 'x' : network
    });

    this.$emit('open', network);
  }
}
